import { type LevelProgressNote } from '@/lib/types';
import { IconButton } from '@mui/material';
import { useContext, useState } from 'react';
import HtmlRenderer from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/utils/HtmlRenderer';
import CommentUser from '@/components/comment/CommentUser';
import CommentHeader from '@/components/comment/CommentHeader';
import CommentActionsWrapper from '@/components/comment/CommentActionsWrapper';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import { Edit as EditIcon } from '@mui/icons-material';
import PortfolioUserContext from '@/lib/contexts/PortfolioUserContext';
import DeleteLevelProgressNote from './DeleteLevelProgressNote';
import LevelProgressNoteEditor from './LevelProgressNoteEditor';
import CommentWrapper from '@/components/comment/CommentWrapper';

type LevelProgressNoteProps = {
  levelProgressNote: LevelProgressNote;
};

const LevelProgressNote = ({ levelProgressNote }: LevelProgressNoteProps) => {
  const portfolioUser = useContext(PortfolioUserContext);

  const [editing, setEditing] = useState(false);

  return (
    <CommentWrapper>
      <CommentHeader>
        <CommentUser
          user={
            typeof levelProgressNote.user !== 'undefined'
              ? levelProgressNote.user
              : portfolioUser
          }
          createdAt={levelProgressNote.createdAt}
        />
        {!editing && (
          <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
            <CommentActionsWrapper>
              <IconButton onClick={() => setEditing(true)} size="small">
                <EditIcon fontSize="small" />
              </IconButton>
              <DeleteLevelProgressNote levelProgressNote={levelProgressNote} />
            </CommentActionsWrapper>
          </RestrictedToPortfolioMode>
        )}
      </CommentHeader>
      {editing ? (
        <LevelProgressNoteEditor
          levelProgressNote={levelProgressNote}
          onClose={() => setEditing(false)}
        />
      ) : (
        <HtmlRenderer source={levelProgressNote.content} darkText />
      )}
    </CommentWrapper>
  );
};

export default LevelProgressNote;
